import React from 'react';
import styles from './Blog.module.css';
import { useLanguage } from '../../context/LanguageContext';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const Blog: React.FC = () => {
  const { t } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="blog" className="section">
      <div className="container">
        <div className={`section-header fade-in ${isVisible ? 'visible' : ''}`}>
          <span className="section-tag">{t.blog.subtitle}</span>
          <h2 className="section-title">{t.blog.title}</h2>
        </div>

        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className={`fade-in ${isVisible ? 'visible' : ''}`}
        >
          <div className={styles.placeholder}>
            <div className={styles.icon}>✍️</div>
            <h3 className={styles.comingSoon}>{t.blog.comingSoon}</h3>
            <p className={styles.desc}>{t.blog.comingSoonDesc}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
